<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()" (cancelForm)="onCancel()">
  <fc-person-list
    [baseId]="baseId"
    [form]="form"
    [isSubmitted]="isSubmitted"
    [listItem]="listItem"
    [itemContext]="fcModalItemContext"
  ></fc-person-list>
</fc-general-modal>
